<template>
  <div class="ARQuickLook">

    <div>

      <a rel="ar" href="./static/amoureux.usdz">
        <img :src="require('./models/amoureux.png')"/>
      </a>

  </div>


  </div>
</template>

<script>

import Settings from '@/config/Settings'
import gsap from "gsap"

export default {

  name: 'ARQuickLook',
  data: ()=>({
    ready: true
  }),
  beforeDestroy() {
  },
  mounted() {
  },
  methods:{
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'


.ARQuickLook 
  width 100%
  height 100%
  position absolute 
  

img 
  width 75%

</style>


